/*!
 * jQuery outside events - v1.1 - 3/16/2010
 * http://benalman.com/projects/jquery-outside-events-plugin/
 * 
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 *
 * Modified by: Kenneth Auchenberg (24. jan 2011)
 */

(function($,doc){
  var event_prefix = 'outside';

  // All these events will get an "outside" event counterpart by default.
  $.map('click dblclick mousemove mousedown mouseup mouseover mouseout change select submit keydown keypress keyup'.split(' '),
    function( event_name ) {
      jq_addOutsideEvent( event_name );
    }
  );
  
  // The focus and blur events are really focusin and focusout when it comes to delegation, so they are a special case.
  jq_addOutsideEvent( 'focusin',  event_prefix + 'focus');
  jq_addOutsideEvent( 'focusout', event_prefix + 'blur' );

  function jq_addOutsideEvent( event_name, outside_event_name ) {
    
    // The "outside" event name.
    outside_event_name = outside_event_name || event_prefix + event_name;

    var elems = $(), event_namespaced = event_name + '.' + outside_event_name + '-special-event';

    $.event.special[ outside_event_name ] = {

      setup: function(){
        elems = elems.add( this );
        if ( elems.length === 1 ) {
          $(doc).bind( event_namespaced, handle_event );
        }
      },

      teardown: function(){
        elems = elems.not( this );
        if ( elems.length === 0 ) {
          $(doc).unbind( event_namespaced );
        }
      },

      add: function( handleObj ) {
        var old_handler = handleObj.handler;
        handleObj.handler = function( event, elem ) {
          event.target = elem;
          old_handler.apply( this, arguments );
        };
      }
    };
    
    function handle_event( e ) {
      $(elems).each(function(){
        var elem = $(this);

        if ( this !== e.target && !elem.has(e.target).length ) {
          elem.triggerHandler( outside_event_name, [ e.target ] );
        }
      });
    }
    
  }
  
})(jQuery, document);

define("lib/jquery/jquery.ba-outside-events", ["jquery"], function(){});

